import {request, _urlBrands} from "../api";
import {BRAND_CONSTS, UTIL_CONSTS} from "../constants";
import {history} from "../../configs/history";
import { notificationSuccess } from "../../components/uiElements/Notifications";
import swal from "sweetalert";

export const GetBrands = ({
                                reset = true,
                                offset = 0,
                                badge,
                                limit = 20,

                            } = {}) => {
    let url = `${_urlBrands}?offset=${offset}&limit=${limit}`;
    badge && (url += `&badge=${badge}`);
    const requestData = {
        url,
        token: true,
        method: "GET",
    };

    return dispatch => {
        reset && dispatch({type: UTIL_CONSTS.START_LOADING});
        return request(requestData)
            .then(({data}) => {
                data && dispatch({
                    type: BRAND_CONSTS.GET_BRANDS,
                    payload: {
                        data: data,
                        badge,
                        reset,
                        hasMore: data.length === limit,
                    }
                });
            }).finally(() => {
                dispatch({
                    type: UTIL_CONSTS.END_LOADING
                })
            })
    }
};

export const AddBrand = (data) => {
    const requestData = {
        url: _urlBrands,
        token: true,
        method: "POST",
        data,
    };

    return dispatch => {
        return request(requestData)
            .then(({data}) => {
                notificationSuccess({
                    description: "Տվյալները հաջողությամբ ստեղծվեց!"
                })
                history.push('/brand')
            }).catch(e=>{
                if (e?.response?.status === 409) {
                    swal({
                        title: "Չհաջողվեց!",
                        text: "Slug-ը արդեն օգտագործված է։",
                        icon: "error",
                        button: 'Լավ'
                    });
                }
            })
    }
};

export const UpdateBrand = (id, data) => {
    const requestData = {
        url: `${_urlBrands}/${id}`,
        method: "PATCH",
        token: true,
        data,
    };

    return (dispatch) => {
        return request(requestData)
            .then(({data}) => {
                dispatch({
                    type: BRAND_CONSTS.UPDATE_BRAND,
                    payload: data
                });
                notificationSuccess({
                    description: "Տվյալները հաջողությամբ փոփոխվեց!"
                })
                history.push({
                    pathname: '/brand',
                })
            }).catch(e=>{
                if (e?.response?.status === 409) {
                    swal({
                        title: "Չհաջողվեց!",
                        text: "Slug-ը արդեն օգտագործված է։",
                        icon: "error",
                        button: 'Լավ'
                    });
                }
            })
    }
};

export const GetBrandById = (id) => {
    const requestData = {
        url: `${_urlBrands}/${id}`,
        method: "GET",
        token: true,
    };

    return (dispatch) => {
        return request(requestData)
            .then(({data}) => {
                return data
            })
    }
};

export const DeleteBrand = (id) => {
    const requestData = {
        url: `${_urlBrands}/${id}`,
        token: true,
        method: "DELETE",
    };

    return dispatch => {
        return request(requestData)
            .then(({data}) => {
                dispatch({
                    type: BRAND_CONSTS.DELETE_BRAND,
                    payload: id
                });
                notificationSuccess({
                    description: "Տվյալները հաջողությամբ ջնջվեց!"
                })

            })
    }
};

export const AppendBrand = (brand) => {
    return dispatch => {
        dispatch({
            type: BRAND_CONSTS.APPEND_BRAND,
            payload: brand
        });
    }
};
